export default "__VITE_ASSET__28242e2c__"